import { useState } from "react";
import Grid from "../../../../fragments/Grid";
import CaseDetailsInsuranceTagItem from "./CaseDetailsInsuranceTagItem";

export default function CaseDetailsInsuranceTagV2() {

    const [initialState, setInitialState] = useState([
        {
            name: 'Commercial',
            active: false,
            color: 'Grey',
            label: 'liability_is_commercial_policy',
            label_on_item: 'commercial_policy'
        },
        {
            name: 'DUI',
            active: false,
            color: 'Grey',
            label: 'liability_is_dui',
            label_on_item: 'dui'
        },
        {
            name: 'HitandRun',
            active: false,
            color: 'Red',
            label: 'liability_is_hit_run',
            label_on_item: 'hit_run'
        },
        {
            name: 'Rideshare',
            active: false,
            color: 'Grey',
            label: 'liability_is_ride_share',
            label_on_item: 'ride_share'
        }
    ])

    return <Grid columns={4} margin='top' gap={8}>
        {initialState && initialState.map(item => (
            <CaseDetailsInsuranceTagItem key={item.label} item={item}/>
        ))}     
    </Grid>
}